<template>
  <div style="margin: 30px;font-weight: bold;font-style: italic;">alcondis BauTime V202412a

  </div>
  <div v-if="statusMSG" class="sysInfo">{{ statusMSG }}</div>
  <div v-if="st_user_sel || isOnline == 'No' ? false : true">
    <span style="margin-top: 20px">PIN: <input type="password" v-model="st_user_sel_pin" /></span><br />
    <div v-for="item in st_meta_data" v-bind:key="item.st_user_code" style="margin-top: 20px">
      <button v-on:click="users_check(item)">
        {{ item.st_user_name }}
      </button>
    </div>
  </div>
  <div v-if="!edit_mode">
    {{ st_user_sel.st_user_name }}
    <br />
    <div v-for="item in st_users_projects_data" v-bind:key="item.st_prj_code" style="margin-top: 20px">
      <button v-on:click="st_project_sel = item; edit_mode = true">{{ item.st_prj_name }}</button>
    </div>
    <br />
    <!--button v-on:click="cancel_button()" class="cancel_button">Abmelden</button-->
  </div>
  <div v-if="edit_mode" style="width: 280px">
    <span style="font-size: 30px; font-weight: bold">{{
      st_project_sel.st_prj_name
      }}</span>
    <table class="tab_view">
      <tbody>
        <tr>
          <td>Datum</td>
          <td><input type="date" ref="curTskDate" v-model="st_project_item_datum" /></td>
        </tr>
        <tr>
          <td>Zeit:</td>
          <td>
            <input type="number" v-model="st_project_item_zeit" style="width: 40px" />h
            <input type="number" v-model="st_project_item_zeit_min" style="width: 40px" />min.<br />
            <button v-on:click="st_project_item_zeit = st_project_item_zeit + 1">
              1h plus</button><br />
            <button v-on:click="
              st_project_item_zeit_min =
              st_project_item_zeit_min > 30
                ? 0
                : st_project_item_zeit_min + 15
              ">
              15m plus
            </button>
          </td>
        </tr>
        <tr>
          <td>Was gemacht</td>
          <td>
            <textarea rows="10" cols="25" v-model="st_project_item_txt"></textarea>
          </td>
        </tr>
      </tbody>
    </table>
    <br />
    <button v-on:click="edit_mode=false" class="cancel_button">
      Abbruch
    </button>
    <br /><br />
    <button v-on:click="saveTask()" v-if="st_edit_st_tsk_id < 0">Speichern</button>
    <button v-on:click="saveTask()" v-if="st_edit_st_tsk_id > 0">Anpassen</button>
  </div>
  <div v-if="st_users_task_data" style="width: 280px; text-align: center">
    <table class="tab_view" style="width: 279px">
      <thead>
        <tr>
          <th>Projekt</th>
          <th style="width: 90px; text-align: center">Datum</th>
          <th style="width: 60px; text-align: center">Zeit</th>
          <th style="width: 60px; text-align: center">Aktion</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="titem in st_users_task_data" v-bind:key="titem" v-bind:title="titem.st_tsk_detail">
          <td>{{ titem.st_prj_name }}</td>
          <td style="text-align: center">{{ fdate(titem.st_tsk_date_ts) }}</td>
          <td style="text-align: center">{{ getFullHourMinute(titem.st_tsk_hours) + ":" +
            getFullHourMinute(titem.st_tsk_minutes) }}</td>
          <td style="text-align: center"><span class="act_button" v-on:click="delTask(titem.st_tsk_id)">Löschen</span>
            <br>
            <span class="act_button" v-on:click="editTask(titem)">Ändern</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "App",
  mounted: function () {
    console.log("App mounted");
    this.loadMetaApp();
  },
  data() {
    return {
      currUser: "",
      edit_mode: false,
      isOnline: "No",
      statusMSG: "",
      core_url: this.getContext(),
      myTimer: "",
      myTimerCounter: 0,
      st_meta_data: "",
      st_user_sel: "",
      st_user_sel_pin: "",
      st_users_projects_data: "",
      st_project_sel: "",
      st_project_item_datum: "",
      st_project_item_zeit: 0,
      st_project_item_zeit_min: 0,
      st_project_item_txt: "",
      st_users_task_data: "",
      st_edit_st_tsk_id: -1,
    };
  },
  computed: {
    isDispo: function () {
      return true;
    },
  },
  methods: {
    getContext() {
      var url = window.location.href;
      if (url.includes(":3000")) return "http://localhost:8080/carforce/core";
      //https://dev.alcondis.net/alcore/core
      return "https://dev.alcondis.net/alcore/core";
    }, //load meta data
    loadMetaApp() {
      //var token = window.localStorage.getItem("carforce_rqtoken");
      this.statusMSG = "";
      var comp = this;

      var d = new Date();
      var n = d.getTime();

      var xmlhttp = new XMLHttpRequest();
      var myAppDataURL = this.getContext() + "?action=qjason&jsc=st_users";
      var url = myAppDataURL + "&z=" + n;
      console.log("Try data get meta data ... " + url);

      xmlhttp.onerror = function (e) {
        console.log(e);
        comp.statusMSG =
          "Server may offline - please reload page after a few minutes ...";
      };

      xmlhttp.onreadystatechange = function () {
        if (this.readyState == 4 && this.status == 200) {
          if (this.responseText != null) {
            comp.isOnline = "Yes";
            var theResult = JSON.parse(this.responseText);
            if (theResult && theResult.error && theResult.error == 1) {
              console.log("ERROR: ", this.responseText);
            } else if (theResult && theResult[0]) {
              console.log("Meta data found and set.");
              comp.st_meta_data = theResult;
            } else {
              comp.st_meta_data = "";
            }
          }
        } else if (this.readyState == 4 && this.status != 200) {
          comp.statusMSG = "Server not responding. Status: " + this.status;
        }
      };
      xmlhttp.open("GET", url, true);

      xmlhttp.send();
    },
    getFullHourMinute(hm) {
      if (hm && hm < 10) return "0" + hm;
      return hm;
    },
    editTask(tskEdit) {
      console.log(JSON.stringify(tskEdit));
      this.st_project_sel = tskEdit;
      this.edit_mode = true;
      //st_project_item_datum
      this.st_project_item_txt = tskEdit.st_tsk_detail;
      this.st_project_item_zeit = tskEdit.st_tsk_hours ? parseInt(tskEdit.st_tsk_hours) : 0;
      this.st_project_item_zeit_min = tskEdit.st_tsk_minutes ? parseInt(tskEdit.st_tsk_minutes) : 0;
      this.st_edit_st_tsk_id = tskEdit.st_tsk_id ? parseInt(tskEdit.st_tsk_id) : -1;
      this.st_project_item_datum = tskEdit.st_tsk_date.substring(0, 10);

      /*
        {"st_tsk_minutes":"0","st_tsk_id":7,"st_prj_name":"GG13-Dach","st_tsk_date":"2024-12-23 00:00:00",
        "st_tsk_date_ts":1734908400000,"st_tsk_created":"2024-12-29 14:09:42","st_tsk_hours":"4",
        "st_tsk_detail":"Haus Sued Dach","st_tsk_created_ts":1735477782000,"row_num":1}
      */
    },
    saveTask() {
      if (this.st_project_item_zeit == 0 && this.st_project_item_zeit_min == 0) {
        alert("Bitte eine zeit eingeben!");
        return;
      }
      //SAVE/up_date
      var myComponent = this;
      var sSQL = this.st_edit_st_tsk_id > 0 ? "st_task_upd" : "st_task_cr";
      var d = new Date();
      var n = d.getTime();
      var xmlhttp = new XMLHttpRequest();
      var jSonContent = {};
      /*--
      st_tsk_project,
      st_tsk_user,
      st_tsk_date,
      st_tsk_detail,
      st_tsk_hours,
      st_tsk_minutes//*/
      jSonContent["1_String"] = this.st_project_sel.st_prj_code;
      jSonContent["2_String"] = this.st_user_sel.st_user_code;
      var date2 = this.st_project_item_datum ? new Date(this.st_project_item_datum) : new Date();
      var timestamp = date2.getTime();
      jSonContent["3_ltimestamp"] = timestamp;
      jSonContent["4_String"] = this.st_project_item_txt;
      jSonContent["5_Integer"] = this.st_project_item_zeit;
      jSonContent["6_Integer"] = this.st_project_item_zeit_min;
      //only Update
      if (this.st_edit_st_tsk_id > 0) {
        jSonContent["7_Integer"] = this.st_edit_st_tsk_id;
      }
      
      var myAppDataURL =
        this.$root.core_url +
        "?action=sfoisup&jsc=" +
        sSQL +
        "&isjson=1&secret=64291a";
      var url = myAppDataURL + "&z=" + n;
      console.log("DEBUG:", url);
      xmlhttp.onreadystatechange = function () {
        if (this.readyState == 4 && this.status == 200) {
          //console.log(this.responseText);
          myComponent.st_task_user_list();
          myComponent.edit_mode = false;
          myComponent.st_project_item_txt = "";
          myComponent.st_project_item_zeit = 0;
          myComponent.st_project_item_zeit_min = 0;
          myComponent.st_project_item_datum = "";
        } else if (this.readyState == 4 && this.status != 200) {
          alert("Error loadWfItems request:" + this.status);
        }
      };
      xmlhttp.open("POST", url, true);
      xmlhttp.setRequestHeader(
        "Content-Type",
        "application/json;charset=UTF-8"
      );

      xmlhttp.setRequestHeader(
        "Authorization",
        window.localStorage.getItem("carforce_rqtoken")
      );
      xmlhttp.send(JSON.stringify(jSonContent));
      this.st_edit_st_tsk_id = -1;
    },
    delTask(tsakID) {
      if (!tsakID || tsakID < 1) {
        alert("Keine ID zum löschen!");
        return;
      }
      //SAVE/up_date
      var myComponent = this;
      var sSQL = "st_task_rm";
      var d = new Date();
      var n = d.getTime();
      var xmlhttp = new XMLHttpRequest();
      var jSonContent = {};
      /*--
      st_tsk_id//*/
      jSonContent["1_Integer"] = tsakID;

      var myAppDataURL =
        this.$root.core_url +
        "?action=sfoisup&jsc=" +
        sSQL +
        "&isjson=1&secret=64291a";
      var url = myAppDataURL + "&z=" + n;
      console.log("DEBUG:", url);
      xmlhttp.onreadystatechange = function () {
        if (this.readyState == 4 && this.status == 200) {
          console.log(this.responseText);
          myComponent.st_task_user_list();
        } else if (this.readyState == 4 && this.status != 200) {
          alert("Error loadWfItems request:" + this.status);
        }
      };
      xmlhttp.open("POST", url, true);
      xmlhttp.setRequestHeader(
        "Content-Type",
        "application/json;charset=UTF-8"
      );

      xmlhttp.setRequestHeader(
        "Authorization",
        window.localStorage.getItem("carforce_rqtoken")
      );
      xmlhttp.send(JSON.stringify(jSonContent));
    },
    fdate(ts) {
      try {
        var d = new Date(+ts);
        var day = d.getDate();
        day = day < 10 ? "0" + day : day;
        var m = d.getMonth() + 1;
        m = m < 10 ? "0" + m : m;
        return day + "." + m + "." + d.getFullYear();
      } catch (e) {
        console.log(e);
        return "--";
      }
    },
    fdatetime(ts) {
      try {
        var d = new Date(+ts);
        var day = d.getDate();
        day = day < 10 ? "0" + day : day;
        var m = d.getMonth() + 1;
        m = m < 10 ? "0" + m : m;
        var hour = d.getHours();
        hour = hour < 10 ? "0" + hour : hour;
        var min = d.getMinutes();
        min = min < 10 ? "0" + min : min;
        var sec = d.getSeconds();
        sec = sec < 10 ? "0" + sec : sec;
        return (
          day +
          "." +
          m +
          "." +
          d.getFullYear() +
          " " +
          hour +
          ":" +
          min +
          ":" +
          sec
        );
      } catch (e) {
        console.log(e);
        return "--";
      }
    },
    st_task_user_list() {
      console.log("Reading users project tasks ...");
      this.statusMSG = "";
      this.st_users_projects_data = "";
      var comp = this;

      var d = new Date();
      var n = d.getTime();

      var xmlhttp = new XMLHttpRequest();
      var myAppDataURL =
        this.getContext() +
        "?action=qjason&jsc=st_task_user_list&psstr1=" +
        this.st_user_sel.st_user_code;
      var url = myAppDataURL + "&z=" + n;
      console.log("Try data get meta data ... ");

      xmlhttp.onerror = function (e) {
        console.log(e);
        comp.statusMSG =
          "Server may offline - please reload page after a few minutes ...";
      };

      xmlhttp.onreadystatechange = function () {
        if (this.readyState == 4 && this.status == 200) {
          if (this.responseText != null) {
            var theResult = JSON.parse(this.responseText);
            //console.log("SEL PRJ: ", this.responseText);
            if (theResult && theResult.error && theResult.error == 1) {
              console.log("ERROR: ", theResult.msg);
            } else if (theResult && theResult[0]) {
              console.log("Meta data found and set.");
              comp.st_users_task_data = theResult;
              comp.users_projects(comp.st_user_sel.st_user_code);
              
            } else {
              comp.st_users_task_data = "";
            }
          }
        } else if (this.readyState == 4 && this.status != 200) {
          comp.statusMSG = "Server not responding. Status: " + this.status;
        }
      };
      xmlhttp.open("GET", url, true);

      xmlhttp.send();
    },
    // st_users_projects
    users_projects(user_code) {
      console.log("Reading users projects: ", user_code);
      this.statusMSG = "";
      this.st_users_projects_data = "";
      var comp = this;

      var d = new Date();
      var n = d.getTime();

      var xmlhttp = new XMLHttpRequest();
      var myAppDataURL =
        this.getContext() +
        "?action=qjason&jsc=st_users_projects&psstr1=" +
        user_code;
      var url = myAppDataURL + "&z=" + n;
      console.log("Try data get meta data ... ");

      xmlhttp.onerror = function (e) {
        console.log(e);
        comp.statusMSG =
          "Server may offline - please reload page after a few minutes ...";
      };

      xmlhttp.onreadystatechange = function () {
        if (this.readyState == 4 && this.status == 200) {
          if (this.responseText != null) {
            var theResult = JSON.parse(this.responseText);
            console.log("SEL PRJ: ", this.responseText);
            if (theResult && theResult.error && theResult.error == 1) {
              console.log("ERROR: ", theResult.msg);
            } else if (theResult && theResult[0]) {
              console.log("Meta data found and set.");
              comp.st_users_projects_data = theResult;
            } else {
              comp.st_users_projects_data = "";
            }
          }
        } else if (this.readyState == 4 && this.status != 200) {
          comp.statusMSG = "Server not responding. Status: " + this.status;
        }
      };
      xmlhttp.open("GET", url, true);

      xmlhttp.send();
    },
    cancel_button() {
      //this.st_user_sel="";
      //this.st_user_sel_pin="";
      //this.st_users_projects_data="";
      this.st_project_sel = "";
      this.edit_mode = false;
      this.st_project_item_datum = "";
      this.st_project_item_zeit = 0;
      this.st_project_item_zeit_min = 0;
      this.st_project_item_txt = "";
      //this.st_users_task_data= "";
    },
    users_check(useritem) {
      console.log("Check user ... ");
      if (!this.st_user_sel_pin || this.st_user_sel_pin.length < 5) {
        alert("Not a valid PIN");
        return;
      }
      this.statusMSG = "";
      this.st_users_projects_data = "";
      var comp = this;

      var d = new Date();
      var n = d.getTime();

      var xmlhttp = new XMLHttpRequest();
      var myAppDataURL =
        this.getContext() +
        "?action=qjason&jsc=st_users_check&psstr1=" +
        useritem.st_user_code +
        "&psstr2=" +
        this.st_user_sel_pin;
      var url = myAppDataURL + "&z=" + n;
      console.log("Try data get meta data ... ");

      xmlhttp.onerror = function (e) {
        console.log(e);
        comp.statusMSG =
          "Server may offline - please reload page after a few minutes ...";
      };

      xmlhttp.onreadystatechange = function () {
        if (this.readyState == 4 && this.status == 200) {
          if (this.responseText != null) {
            var theResult = JSON.parse(this.responseText);
            console.log("SEL USer: ", this.responseText);
            if (theResult && theResult.error && theResult.error == 1) {
              console.log("ERROR: ", theResult.msg);
            } else if (theResult && theResult[0].OK && theResult[0].OK == 1) {
              console.log("Meta data found and set.");
              comp.st_user_sel = useritem;
              comp.st_task_user_list();
              comp.users_projects(useritem.st_user_code);
            } else {
              comp.st_user_sel = "";
              comp.st_users_projects_data = "";
              comp.st_users_task_data = "";
              alert("Wrong credentials");
            }
          }
        } else if (this.readyState == 4 && this.status != 200) {
          comp.statusMSG = "Server not responding. Status: " + this.status;
        }
      };
      xmlhttp.open("GET", url, true);

      xmlhttp.send();
    },
  },
};
</script>

<style>
@import "./styles.css";
</style>
